import { createSlice } from "@reduxjs/toolkit";
import { showRoleUser, createRoleUser } from "../actions";

const initialState = {
  roleUser: [],
};

const roleUserSlice = createSlice({
  name: "roleUser",
  initialState,
  reducers: {},
  extraReducers: {
    [showRoleUser.fulfilled]: (state, action) => {
      state.roleUser = action.payload || [];
    },
    [createRoleUser.fulfilled]: (state, action) => {
      state.roleUser = action.payload || [];
    }
  },
});

export const responseRoleUser = (state) => state.roleUser;

export default roleUserSlice.reducer;
